import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Icon, Message, Popup } from 'semantic-ui-react';
import { Box } from '../../components/Box';
import FormView from '../editor/components/views/FormView';
import BottomFloatingPanel from '../frontoffice/components/BottomFloatingPanel';
import Stepper from '../frontoffice/components/Stepper';
import { StripePaymentModal } from './components/StripePaymentModal';
import { Spin, message } from 'antd';
import { Auth } from 'aws-amplify';
import moment from 'moment';
import { customAlphabet } from 'nanoid';
import { DATE_TIME_FORMAT } from '../.././constants';
import {
  GetCraftsAction,
  SaveOrderAction,
  SetActiveArtifact,
  SetLanguage,
  UpdateOrderAction,
  UpdateOrderFormstateAction,
} from '../../app/ActionsImpl';
import { evaluateArtifactValidity, getInvalidFields } from '../../utils/ArtifactValidator';
import { translations } from '../../utils/LocalizedStrings';
import { getAllUrlParams } from '../../utils/url';
import { hashValues } from '../editor/components/views/AdminEditor/Constants';
import LoginModal from './components/LoginModal';
import { ValidatorModal } from './components/ValidatorModal';

function FrontOfficeTemplate({
  changeOpenedDocument,
  documents = [],
  activeDocumentKey,
  selectedSteps,
  dateOfMeeting,
  getCrafts,
  metadata,
  values,
  setActiveArtifact,
  templateId,
  saveOrder,
  updateOrder,
  flowId,
  template,
  templateShortId,
  updated_at,
  orderToEdit,
  admin,
  regenerateOrderFiles,
  user,
  userOrdersCount,
  language,
  setLanguage
}) {
  const editorState = useSelector((state) => state.editor.editorState);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [priceToRefund, setPriceToRefund] = useState(false);

  const [validatorModalVisible, setValidatorModalVisible] = useState(false);
  const [invalidArtifacts, setInvalidArtifacts] = useState([]);
  const [cachedFieldsAsObject, setCachedFieldsAsObject] = useState({});
  const [lessons, setLessons] = useState();

  const history = useHistory();
  const params = useParams();

  const [hideMap, setHideMap] = useState({});
  const [isActiveShoppingcart, setActiveShoppingcart] = useState(false);

  const toggleClass = () => {
    setActiveShoppingcart(!isActiveShoppingcart);
  };

  const [allDocuments, setDocuments] = useState([]);
  const [buttonTitle, setButtonTitle] = useState('Ďalej');
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showIcon, setShowIcon] = useState('');
  const [iconClassName, setIconClassName] = useState('bounce');

  const [clearSteps, setClearSteps] = useState([]);
  const [clearDocuments, setClearDocuments] = useState([]);

  const [fieldValues, setFieldValues] = useState({});
  const [previousFieldValues, setPreviousFieldValues] = useState({});
  const [allFoundArtifacts, setAllFoundArtifacts] = useState({});

  const [hashValuesMap, setHashValuesMap] = useState(new Map());

  const [guidanceId, setGuidanceId] = useState(0);

  const [leftWindow, setLeftWindow] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [documentsMap, setDocumentsMap] = useState(false);

  const [shouldSaveOrder, setShouldSaveOrder] = useState(false)

  const [infoText, setInfoText] = useState('');
  const [infoVisible, setInfoVisible] = useState(false);

  const [continueToGeneration, setContinueToGeneration] = useState(false)
  const [tmpFormData, setTmpFormData] = useState(undefined);
  const [cognitoError, setCognitoError] = useState(undefined);
  const [newCognitoUser, setNewCognitoUser] = useState(undefined)
  const [previousInvalidFields, setInvalidFields] = useState([]);

  const nanoid = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVXYZ1234567890', 4)

  useEffect(() => {
    let docMap = {}
    if (allDocuments) {
      for (let doc of allDocuments) {
        docMap[doc.id.split("-")[0]] = doc
      }
      if (JSON.stringify(docMap) !== JSON.stringify(documentsMap)) {
        setDocumentsMap(docMap)
      }
    }
  }, [allDocuments])


  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = '';
  };
  const search = useLocation().search;

  function mouseOutListener(event) {
    if (event) {
      if (
        event.clientY <= 0 ||
        event.clientX <= 0 ||
        event.clientX >= window.innerWidth ||
        event.clientY >= window.innerHeight
      ) {
        setLeftWindow(true);
      }
    }
  }

  useEffect(() => {
    if (leftWindow) {
      if (templateId) {
        handleSave();
        setLeftWindow(false);
      }
    }
  }, [leftWindow]);

  useEffect(() => {
    window.addEventListener('mouseout', mouseOutListener, true);
    return () => {
      window.removeEventListener('mouseout', mouseOutListener, true);
    };
  }, []);


  useEffect(() => {
    getCrafts();
    window.addEventListener('beforeunload', alertUser);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
  }, []);



  let stepsArray = [
    translations.artifacts.StepperBox.firstStep,
    translations.artifacts.StepperBox.secondStep,
    translations.artifacts.StepperBox.thirdStep,
    translations.artifacts.StepperBox.fourthStep,
  ];

  useEffect(() => {
    let search = window.location.search
    if (templateId && getAllUrlParams().order === undefined) {
      if (search.indexOf("?") !== -1) {
        search += '&order=' + templateId
      } else {
        search += '?order=' + templateId
      }
      if (history) {
        history.push({
          pathname: window.location.pathname,
          search: search
        })
      }
    }
  }, [templateId])

  useEffect(() => {
    let newSteps = [];
    for (let document of clearDocuments) {
      let clearId = document.id.split('-')[0];
      if (
        (selectedSteps.indexOf(clearId) !== -1 &&
          newSteps.indexOf(clearId) === -1) ||
        document.value.isAlwaysPaid
      ) {
        newSteps.push(clearId);
      }
    }
    setClearSteps(newSteps);
  }, [clearDocuments]);

  useEffect(() => {
    if (continueToGeneration && tmpFormData && (newCognitoUser || user)) {

      let formData2Send = tmpFormData

      delete formData2Send.pass1
      delete formData2Send.pass2

      const tmpParams = {
        flow_id: params.id,
        formData: formData2Send,
        params: { flow_id: params.id, formData: formData2Send },
        shortId: nanoid(),
        steps: allDocuments.map((doc) => {
          return { id: doc.id, parentStepId: doc.parentStepId };
        }),
      }
      history.push('/document-download' + window.location.search, tmpParams);
    }
  }, [continueToGeneration, tmpFormData, newCognitoUser])

  const setAllDocuments = (finalDocs) => {
    setDocuments(finalDocs);
    if (
      activeDocumentKey === undefined ||
      activeDocumentKey === '' ||
      activeDocumentKey === null
    ) {
      changeOpenedDocument(finalDocs[0].id);
    }
  };

  const handleChangeOpenedDocument = (key, next, noScroll) => {
    let currentDocIndex;
    let nextDocIndex;
    let index = 0;
    if (allDocuments) {
      for (let document of allDocuments) {
        if (document.id === activeDocumentKey) {
          currentDocIndex = index;
        }
        if (document.id === key) {
          nextDocIndex = index;
        }
        index += 1;
      }
    }
    index = 0;
    if (values && currentDocIndex < nextDocIndex) {
      let parsedValues = JSON.parse(values);
      if (allDocuments) {
        changeOpenedDocument(key, next, noScroll);
      }
    } else {
      changeOpenedDocument(key, next, noScroll);
    }
  };

  useEffect(() => {
    let filteredDocuments = allDocuments.filter(
      (document) => document.value.isHidden !== true,
    );
    if (
      activeDocumentKey === undefined ||
      activeDocumentKey === '' ||
      activeDocumentKey === null
    ) {
      return;
    } else if (
      filteredDocuments[filteredDocuments.length - 1] &&
      activeDocumentKey === filteredDocuments[filteredDocuments.length - 1].id
    ) {
      if (admin) {
        setButtonTitle('Pregenerovať dokumenty');
      } else {
        setButtonTitle('Vytvoriť dokument');
      }
      setShowIcon('');
      setIconClassName('notDisplayed');
      setButtonDisabled(false);
    } else {
      setButtonTitle('Ďalej');
      setShowIcon('angle double down');
      setIconClassName('bounce');
      setButtonDisabled(false);
    }
  });


  useEffect(() => {
    let tmpHashValuesMap = new Map();
    hashValues.map((item) => {
      if (item.id === 'HLASOVANIE-DATA-OBJECT') {
        tmpHashValuesMap.set(item.id, 'Hlasovanie - rozhodnutie nebolo prijaté');
      } else {
        tmpHashValuesMap.set(item.id, item.value);
      }
    });
    setHashValuesMap(tmpHashValuesMap);
  }, []);

  const validateForm = () => {
    setInvalidArtifacts([]); //sem budeme pridavat artifakty ktore nie su validne

    setCachedFieldsAsObject({}); // toto je objekt artifaktov podla id, tu najdeme typ artifaktu atp
    let tmpCachedField = {};
    Object.entries(fieldValues)?.forEach(([key, field]) => {
      if (field && field.id) {
        tmpCachedField[field.id] = field;
      }
    });
    setCachedFieldsAsObject(tmpCachedField);

    let mapDocs = {};
    allDocuments.forEach((tmpDoc) => {
      mapDocs[tmpDoc.id] = {
        docName: tmpDoc.name,
        isHidden: tmpDoc.value.isHidden,
        artifactIds: new Set(),
      };
    });

    let tmpInvalidArtifacts = [];
    Object.entries(allFoundArtifacts).forEach(([docId, artifacts]) => {
      if (!mapDocs[docId].isHidden)
        artifacts.forEach((artifact) => {
          let artifactId = artifact.replaceAll('"', '').replace('data-id=', '');
          if (
            !evaluateArtifactValidity(artifactId, fieldValues, tmpCachedField, docId)
          ) {
            tmpInvalidArtifacts.push({ artifactId, docId });
          }
        });
    });
    let invalidFields = [];
    for (let art of tmpInvalidArtifacts) {
      console.log(getInvalidFields(art.artifactId, fieldValues, tmpCachedField, art.docId))
      invalidFields = invalidFields.concat(getInvalidFields(art.artifactId, fieldValues, tmpCachedField, art.docId))
    }

    for (let field of previousInvalidFields) {
      var validIdSelector = '[id="' + field + '"]';
      var elements = document.querySelectorAll(validIdSelector);
      if (elements.length === 0) {
        console.warn("No elements found with ID " + field + ".");
      }
      elements.forEach(function (element) {
        element.classList.remove("error-validation");
      });
    }

    for (let field of invalidFields) {
      var validIdSelector = '[id="' + field + '"]';
      var elements = document.querySelectorAll(validIdSelector);
      if (elements.length === 0) {
        console.warn("No elements found with ID " + field + ".");
      }
      elements.forEach(function (element) {
        element.classList.add("error-validation");
      });
    }
    setInvalidFields(invalidFields)

    // vo fieldvalues su hodnoty, tu treba vyhodnotit ci je form validny, ak niektore hodnoty nie su vyplnene, treba zobrazit userovi modal
    // a vypisat mu co nevyplnil a spytat sa ci chce napriek tomu pokracovat, ak da ano, payment modal dame na visible, ak da nie, zavrieme ten modal
    // ak je form validny, tak rovno nastavime payment modal na visible
    if (tmpInvalidArtifacts.length === 0) {
      setPaymentModalVisible(true);
    } else {
      //zobrazime modal a v nom napiseme userovi "Nevyplnili ste nasledujuce hodnoty {artifact.name}, chcete napriek tomu pokracovat?"
      setInvalidArtifacts(tmpInvalidArtifacts);
      setValidatorModalVisible(true);
    }
  };

  function handleSaveOrder() {
    if (templateId) {
      if (JSON.stringify(fieldValues) !== JSON.stringify(previousFieldValues)) {
        let order = {
          template: {
            fieldValues,
            selectedSteps,
            flowId
          },
          id: templateId
        };
        updateOrder(order);
        setPreviousFieldValues(JSON.parse(JSON.stringify(fieldValues)));
      }
    } else {
      let order = {
        template: {
          fieldValues,
          selectedSteps,
          flowId
        },
        username: user.username,
        email: user.attributes.email,
        shortId: nanoid()
      };
      saveOrder(order);
      setPreviousFieldValues(JSON.parse(JSON.stringify(fieldValues)));
    }
  }

  const handleSave = () => {
    if (user) {
      handleSaveOrder()
    } else {
      setShouldSaveOrder(true)
      setLoginModalVisible(true)
    }
  }

  useEffect(() => {
    if (loginModalVisible === false && shouldSaveOrder && user) {
      if (user) {
        setShouldSaveOrder(false)
        handleSave()
      }
    }
  }, [loginModalVisible, user])

  const triggerRegenerateOrder = async () => {
    setIsLoading(true)
    await regenerateOrderFiles(orderToEdit._id, JSON.stringify(fieldValues), selectedSteps, allDocuments.map((doc) => {
      return { id: doc.id, parentStepId: doc.parentStepId };
    }),)
    setIsLoading(false)
  }

  const handleSetLanguage = () => {
    if (language === "sk") {
      setLanguage("en")
    } else {
      setLanguage("sk")
    }
  }

  const createProfile = async (formData) => {
    console.log("USER PROFILE: formData: " + formData)
    try {
      const name = formData.kontakt_meno.split(' ')
      const { user } = await Auth.signUp({
        username: formData.kontakt_email,
        password: formData.pass1,
        attributes: {
          given_name: name.length > 0 ? name[0] : "PROVIDE",
          family_name: name.length > 1 ? name[1] : "NAME",
          phone_number: formData.phone_number,
          'custom:marketing_suhlas': formData['custom:marketing_suhlas'] ? formData['custom:marketing_suhlas'].toString() : 'false'
        }
      });
      setNewCognitoUser(user)
      showMessage("Registrácia bola úspešná.", 10000);
      console.log("Registrácia bola uspesna...")
    } catch (error) {
      console.error("Registrácia bola neúspešná")
      console.error(error)
      if ((error.message.indexOf('account') !== -1) && (error.message.indexOf('exists') !== -1)) {
        setCognitoError(translations.artifacts.CheckouFormBox.cognitoErrorUserExists)
      } else {
        setCognitoError(error.message)
      }
      showMessage(error.message, 3000)
      setContinueToGeneration(false)
      return false
    }
    setCognitoError(undefined)
    setTmpFormData(formData)
    setContinueToGeneration(true)
    return true
  }

  const showMessage = (msg, timeout) => {
    // setInfoText(msg)
    // setInfoVisible(true)
    // setTimeout(() => {
    //   setInfoVisible(false);
    // }, timeout);
    message.error(msg);
  }

  return (
    <Spin spinning={isLoading} size="large" >
      <div className="front">
        <LoginModal
          visible={loginModalVisible}
          handleClose={() => setLoginModalVisible(false)}
        />
        <div className={user ? 'userIconsContainer active' : 'userIconsContainer'}>
          {!admin &&
            <span className='saveOrderContainer'>
              {templateId ? (
                <>
                  <div className="saveOrderInfo desktop">
                    <h5>
                      Váš formulár, ID: {templateShortId}, <br /> bol uložený v čase: {' '}
                      {moment(updated_at).format(DATE_TIME_FORMAT)}.
                    </h5>
                    <Popup className="popupOrderWindow" content='Uloženie dokumentu' trigger={
                      <Icon name="save" onClick={() => handleSave()} />
                    } />
                    <Popup className='popupOrderWindow' content="Načítať stránku znova" trigger={
                      <Icon name='redo' onClick={() => window.location.reload()} />
                    }
                    />
                  </div>
                  <div className='saveOrderInfo mobile'>
                    <div>
                      <Popup className="popupOrderWindow" content={`Váš formulár, ID: ${templateShortId}, bol uložený v čase:
                  ${moment(updated_at).format(DATE_TIME_FORMAT)}.`} trigger={
                          <Icon name="save" onClick={() => handleSave()} />
                        } />
                      <span className='templateIDMobile'><strong>ID: </strong>{templateShortId}</span>
                    </div>
                    <Popup className='popupOrderWindow' content="Načítať stránku znova" trigger={
                      <Icon name='redo' onClick={() => window.location.reload()} />
                    }
                    />
                  </div>
                </>
              ) : (
                !orderToEdit &&
                <div className="saveOrderInfo" onClick={() => handleSave()}>
                  <h5>
                    Uloženie <br />dokumentu
                  </h5>
                  <Popup className="popupOrderWindow" content='Uloženie dokumentu' trigger={
                    <Icon name="save" />
                  } />
                </div>
              )}
            </span>
          }
          {/* <Popup className="popupOrderWindow" content='Zmena jazyka' trigger={
            <span onClick={handleSetLanguage} className='orderBasketIcon'>
              <img className='languageFlag' src={language === "sk" ? SlovakiaFlag : EnglishFlag} alt='flag' />
            </span>} /> */}
          <Popup className="popupOrderWindow" content='Zobraziť sprievodcu aplikáciou' trigger={
            <span className='orderBasketIcon'>
              <Icon name="help circle" />
            </span>} />
          <span className="orderBasketIcon user" onClick={() => { setLoginModalVisible(true) }}>
            <Icon name="user" />
            {user &&
              <strong className='iconUserName'>{user.attributes.given_name}</strong>
            }
          </span>
        </div>
        <Stepper steps={stepsArray} currentStepNumber={2} />
        <Box
          flexDirection="row"
          id='mainContainer'
          flex={1}
          display="flex"
          minHeight="calc(100vh - 4.5rem)"
          background="#fbfbfb">
          {/* Side navigation */}
          <FormView
            setAllDocuments={setAllDocuments}
            dateOfMeeting={dateOfMeeting}
            changeOpenedDocument={handleChangeOpenedDocument}
            hideMap={hideMap}
            activeDocumentKey={activeDocumentKey}
            selectedSteps={selectedSteps}
            setClearDocuments={setClearDocuments}
            overrideDocuments={documents}
            setHideMap={setHideMap}
            returnFieldValues={setFieldValues}
            initFieldValues={(e) => {
              setPreviousFieldValues(JSON.parse(JSON.stringify(e)));
            }}
            setAllFoundArtifacts={setAllFoundArtifacts}
            lessons={lessons}
          />
        </Box>
        <StripePaymentModal
          returnLessons={setLessons}
          documents={documents}
          documentsMap={documentsMap}
          clearSteps={clearSteps}
          selectedSteps={selectedSteps}
          visible={paymentModalVisible}
          templateId={templateId}
          handleClose={() => setPaymentModalVisible(false)}
          values={values ? JSON.parse(values) : {}}
          handleDone={(formData) => {

            if (user === undefined) {
              setTmpFormData(undefined)
              createProfile(formData)
            } else {
              setTmpFormData(formData)
              setContinueToGeneration(true)
            }
          }}
        />
        <ValidatorModal
          visible={validatorModalVisible}
          invalidArtifacts={invalidArtifacts}
          cachedFieldsAsObject={cachedFieldsAsObject}
          hashValuesMap={hashValuesMap}
          handleClose={() => setValidatorModalVisible(false)}
          handlePaymentClose={() => setPaymentModalVisible(false)}
          handlePaymentShow={() => setPaymentModalVisible(true)}
          setActiveArtifact={setActiveArtifact}
          changeOpenedDocument={changeOpenedDocument}
          allDocuments={allDocuments}
        />
        <BottomFloatingPanel
          buttonTitle={buttonTitle}
          showIcon={showIcon}
          iconClassName={iconClassName}
          handleDone={() => {
            if (!buttonDisabled) {
              let filteredDocuments = allDocuments.filter(
                (document) => document.value.isHidden !== true,
              );
              if (
                activeDocumentKey === filteredDocuments[filteredDocuments.length - 1].id
              ) {
                if (admin) {
                  triggerRegenerateOrder()
                } else {
                  if (user) {
                    validateForm();
                  } else {
                    setLoginModalVisible(true)
                  }
                }
              } else {
                let newKey = '';
                if (
                  activeDocumentKey === undefined ||
                  activeDocumentKey === '' ||
                  activeDocumentKey === null
                ) {
                  newKey = allDocuments[1].id;
                } else {
                  let index = 0;
                  for (let doc of filteredDocuments) {
                    if (doc.id === activeDocumentKey) {
                      newKey = filteredDocuments[index + 1].id;
                      break;
                    }
                    index += 1;
                  }
                }
                handleChangeOpenedDocument(newKey, false);
              }
            } else {
              var elem = document.getElementById(`${guidanceId}_guidance_button`);
              if (elem && typeof elem.onclick == "function") {
                elem.click()
              }
            }
          }}
        />
      </div>
      {infoVisible &&
        <Message
          className='infoMessage'
          id="infoMessage"
          header='Informácia'
          content={infoText}
        />
      }
    </Spin>
  );
}

const mapStateToProps = ({ appState, editor }) => ({
  zivnosti: appState.zivnosti,
  metadata: editor.editorState.metadata,
  values: editor.formStatePayload,
  templateId: appState.templateId,
  userEmailFromTemplate: appState.userEmail,
  template: appState.template,
  templateShortId: appState.templateShortId,
  orderToEdit: appState.orderToEdit,
  updated_at: appState.templateSaved,
  user: appState.cognitoUser,
  userOrdersCount: appState.userOrdersAmount,
  language: appState.language
});

const mapDispatchToProps = {
  getCrafts: GetCraftsAction,
  setActiveArtifact: SetActiveArtifact,
  saveOrder: SaveOrderAction,
  updateOrder: UpdateOrderAction,
  regenerateOrderFiles: UpdateOrderFormstateAction,
  setLanguage: SetLanguage
};
export default connect(mapStateToProps, mapDispatchToProps)(FrontOfficeTemplate);
